<template>
  <div class="page-content">
    <!-- 头部区域 -->
    <el-row class="topBar">
      <el-col :span="24" class="buttonCon">
        <el-button  icon="el-icon-refresh-left" @click="refresh">刷新</el-button>
         <!-- <el-button @click="chagneShowView" :type="showListView?'warning':''">列表</el-button>
        <el-button  @click="chagneShowView" :type="!showListView?'warning':''">图表</el-button> -->
      </el-col>
    </el-row>

    <!-- 条件选择区域 -->
    <div class="searchCon">
      <el-row class="product-wrap">
        <el-col :span="3">产品:</el-col>
        <el-col :span="21">
          <el-col class="all">
            <el-button :type="productKey===''?'primary':''" @click="selectClick('productKey','')">全部</el-button>
          </el-col>
          <el-col class="product-item">
            <el-col class="prev" @click.native="prev" v-show="pageQuery.pageNumber !== 1">
              <i class="el-icon-caret-left"></i>
            </el-col>
            <el-col :class="['product',pageQuery.pageNumber === 1?'prev-hidden':'', pageQuery.pageNumber === allPage? 'next-hidden':'']">
              <el-button v-for="item in productList" :key="item.productKey" :type="productKey===item.productKey?'primary':''" @click="selectClick('productKey',item.productKey)">{{item.productName}}</el-button>
            </el-col>
            <el-col class="next" @click.native="next" v-show="pageQuery.pageNumber !== allPage">
              <i class="el-icon-caret-right"></i>
            </el-col>
          </el-col>
        </el-col>
      </el-row>

      <!-- <el-row>
        <el-col :span="3">位置:</el-col>
        <el-col :span="21">
          <el-button :type="positionCurrentIndex===1?'primary':''" @click="selectClick('positionCurrentIndex',1)">全部</el-button>
          <el-button :type="positionCurrentIndex===2?'primary':''" @click="selectClick('positionCurrentIndex',2)">国内</el-button>
          <el-select v-model="selProvinceValue" @change="selProvinceChange" placeholder="请选择地区">
            <el-option
              v-for="item in provinceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
   <transition name="fade-transform" mode="out-in">
      <el-row v-show="currentTabIndex.toString() === '0'" class="status">
        <el-col :span="3">在线状态:</el-col>
        <el-col :span="21" class="top-line">
           <el-button :type="deviceStatus===''?'primary':''" @click="selectClick('deviceStatus','')">全部</el-button>
          <el-button :type="deviceStatus==='0'?'primary':''" @click="selectClick('deviceStatus','0')">在线</el-button>
          <el-button :type="deviceStatus==='1'?'primary':''" @click="selectClick('deviceStatus','1')">离线</el-button>
        </el-col>
      </el-row>
   </transition>
    </div>
    <el-tabs type="card" class="tab" @tab-click="handleClick">
      <el-tab-pane label="设备列表">
        <deviceListView
          v-if="currentTabIndex.toString() === '0'"
          ref="deviceListView"
          :productList="productList"
          :productKey="productKey"
          :deviceStatus="deviceStatus" >
        </deviceListView>
      </el-tab-pane>
      <el-tab-pane label="批次管理">
        <batchManageView
         v-if="currentTabIndex.toString() === '1'"
         ref="batchDeviceListView"
          :productKey="productKey">
        </batchManageView>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { productList } from '@/api/productRegistration'
// import { v4 as uuidv4 } from 'uuid'
import deviceListView from '@/components/deviceManage/deviceListView'
import batchManageView from '@/components/deviceManage/batchManageView'
export default {
  components: {
    deviceListView,
    batchManageView
  },
  data () {
    return {
      // 选择区域用到的数据
      productList: [],
      productKey: '', // 默认显示全部产品下的设备
      deviceStatus: '',
      currentTabIndex: '0',
      pageQuery: {
        pageNumber: 1,
        pageSize: 45
      },
      allPage: 0
    }
  },
  methods: {
    selectClick (key, value) {
      this[key] = value
    },
    // 上一页
    prev () {
      if (this.pageQuery.pageNumber === 1) return
      this.pageQuery.pageNumber--
      this.getOptionsProductList()
    },
    // 下一页
    next () {
      console.log(11)
      if (this.pageQuery.pageNumber === this.allPage) return
      this.pageQuery.pageNumber++
      this.getOptionsProductList()
    },
    getOptionsProductList () {
      /* const params = {
        id: uuidv4(),
        timestamp: Date.parse(new Date()),
        version: '1.0'
      } */
      const params = Object.assign({}, this.pageQuery)
      productList({ params })
        .then(res => {
          const result = res.data.data
          console.log(result)
          this.productList = result.list
          this.allPage = result.pages
          console.log('this.productList:', this.productList)
        })
    },
    // 调用子组件获取设备列表的方法
    refresh () {
      this.currentTabIndex.toString() === '0'
        ? this.$refs.deviceListView.getDeviceList()
        : this.$refs.batchDeviceListView.getDeviceList()
    },
    handleClick (tab) {
      console.log('tab切换：', tab.index)
      this.currentTabIndex = tab.index
    }
  },
  created () {
    if (this.$route.query.productKey) {
      this.selectClick('productKey', this.$route.query.productKey)
    }
    this.getOptionsProductList()
    // this.$router.push(
    //   {
    //     path: '/deviceManagement/DeviceDetail'
    //   }
    // )
  }
}
</script>
<style lang="less" scope>
html{
  background-color: #eaedf1;
}
.page-content {
  .tab{
    margin-top: 20px;
  }
  .topBar{
   .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .buttonCon{
      text-align: right;
      margin-top: -70px;
    }
  }
  .searchCon{
    background-color: #f6f7fa;
    border: 1px solid #dddddd;
    font-size: 16px;
    .el-row{
      display: flex;
      align-items: center;
    }
    .el-button{
      padding: 6px 10px;
      border: 0px;
    }
    .product-wrap{
      .all{
        padding:6px 0 0 20px;
        .el-button{
          border-radius: 0;
        }
      }
      .prev, .next{
        width:20px;
        cursor: pointer;
      }
      .product-item{
        padding: 0 !important;
        display: flex;
        align-items: center;
        .prev-hidden{
          margin-left: 20px;
        }
        .next-hidden{
          margin-right: 20px;
        }
      }
      .el-col-3{
        padding-left: 10px;
      }
      .el-col-21{
        background-color: white;
        .el-button{
          margin-bottom: 10px;
          margin-left: 0
        }
      }
    }
    // 在线状态管理栏
    .status{
      .el-col{
        padding: 10px 0;
      }
      .el-col-3{
        padding-left: 10px;
      }
      .el-col-21{
        background-color: white;
        padding-left: 20px;
      }
    }
    .top-line{
      border-top: solid 1px #dddddd;
    }
    .el-input__inner{
      border: none;
      color: #409EFF;
    }
    .el-input__inner::-webkit-input-placeholder{
         color: #409EFF;
    }
    .el-input__inner::-moz-placeholder{  //不知道为何火狐的placeholder的颜色是粉红色，怎么改都不行，希望有大牛路过帮忙指点
           color: #409EFF;
    }
    .el-input__inner:-ms-input-placeholder{  //由于我的IE刚好是IE9，支持不了placeholder，所以也测试不了(⊙﹏⊙)，有IE10以上的娃可以帮我试试
            color: #409EFF;
    }
    .el-select{
      padding:0px 10px;
    }
    .el-input__suffix{
      display: none;
    }
  }

}
</style>
